
// implements node EventEmitter interface for a more user friendly emitter
// under the hood uses DOM's  EventTarget

export class WebchatEventEmmitter {
    emmitter: EventTarget = new EventTarget(); 
  
    on(event: string, handler: any) {
      if (this.emmitter) {
        //@ts-ignore
        this.emmitter.addEventListener(event, function (evt: CustomEvent) {
          handler(evt.detail);
        });
      }
      else {
        console.error("cannot initialize event emmitter");
      }
    }
    emit(event: string, details: any) {
      let ev = new CustomEvent(event, {
        detail: details
      });
      if (this.emmitter) {
        this.emmitter.dispatchEvent(ev);
      }
      else {
        console.error("cannot use emitter");
      }
    }
  
  }
  